/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Auth service
 * JWT, OAuth, SAML and service-to-service auth routes
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetAuthMeBody,
  PostAuthLogin200,
  PostAuthLoginBody,
  PostAuthLogout200,
  PostAuthLogoutBody,
  PostAuthRefreshToken200,
  PostAuthRefreshTokenBody,
  PostAuthRequestOtp200,
  PostAuthRequestOtpBody
} from '.././schemas';

import { axiosAuth } from '../../../../lib/axiosAuth';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




/**
 * @summary Verify email or phone number + one-time code and start a session
 */
export const postAuthLogin = (
    postAuthLoginBody: PostAuthLoginBody,
 signal?: AbortSignal
) => {
      
      
      return axiosAuth<PostAuthLogin200>(
      {url: `/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthLoginBody, signal
    },
      );
    }
  


export const getPostAuthLoginMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError,{data: PostAuthLoginBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError,{data: PostAuthLoginBody}, TContext> => {

const mutationKey = ['postAuthLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthLogin>>, {data: PostAuthLoginBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthLogin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthLogin>>>
    export type PostAuthLoginMutationBody = PostAuthLoginBody
    export type PostAuthLoginMutationError = void

    /**
 * @summary Verify email or phone number + one-time code and start a session
 */
export const usePostAuthLogin = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError,{data: PostAuthLoginBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuthLogin>>,
        TError,
        {data: PostAuthLoginBody},
        TContext
      > => {

      const mutationOptions = getPostAuthLoginMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Invalidate the current session & JWT cookies
 */
export const postAuthLogout = (
    postAuthLogoutBody?: PostAuthLogoutBody,
 signal?: AbortSignal
) => {
      
      
      return axiosAuth<PostAuthLogout200>(
      {url: `/auth/logout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthLogoutBody, signal
    },
      );
    }
  


export const getPostAuthLogoutMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError,{data: PostAuthLogoutBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError,{data: PostAuthLogoutBody}, TContext> => {

const mutationKey = ['postAuthLogout'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthLogout>>, {data: PostAuthLogoutBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthLogout(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthLogout>>>
    export type PostAuthLogoutMutationBody = PostAuthLogoutBody
    export type PostAuthLogoutMutationError = void

    /**
 * @summary Invalidate the current session & JWT cookies
 */
export const usePostAuthLogout = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError,{data: PostAuthLogoutBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuthLogout>>,
        TError,
        {data: PostAuthLogoutBody},
        TContext
      > => {

      const mutationOptions = getPostAuthLogoutMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Exchange a refresh token for a **new access token**
 */
export const postAuthRefreshToken = (
    postAuthRefreshTokenBody?: PostAuthRefreshTokenBody,
 signal?: AbortSignal
) => {
      
      
      return axiosAuth<PostAuthRefreshToken200>(
      {url: `/auth/refresh-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthRefreshTokenBody, signal
    },
      );
    }
  


export const getPostAuthRefreshTokenMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRefreshToken>>, TError,{data: PostAuthRefreshTokenBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthRefreshToken>>, TError,{data: PostAuthRefreshTokenBody}, TContext> => {

const mutationKey = ['postAuthRefreshToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthRefreshToken>>, {data: PostAuthRefreshTokenBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthRefreshToken(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthRefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthRefreshToken>>>
    export type PostAuthRefreshTokenMutationBody = PostAuthRefreshTokenBody
    export type PostAuthRefreshTokenMutationError = void

    /**
 * @summary Exchange a refresh token for a **new access token**
 */
export const usePostAuthRefreshToken = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRefreshToken>>, TError,{data: PostAuthRefreshTokenBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuthRefreshToken>>,
        TError,
        {data: PostAuthRefreshTokenBody},
        TContext
      > => {

      const mutationOptions = getPostAuthRefreshTokenMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Send a one-time password to the supplied email or phone number
 */
export const postAuthRequestOtp = (
    postAuthRequestOtpBody: PostAuthRequestOtpBody,
 signal?: AbortSignal
) => {
      
      
      return axiosAuth<PostAuthRequestOtp200>(
      {url: `/auth/request-otp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthRequestOtpBody, signal
    },
      );
    }
  


export const getPostAuthRequestOtpMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRequestOtp>>, TError,{data: PostAuthRequestOtpBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthRequestOtp>>, TError,{data: PostAuthRequestOtpBody}, TContext> => {

const mutationKey = ['postAuthRequestOtp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthRequestOtp>>, {data: PostAuthRequestOtpBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthRequestOtp(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthRequestOtpMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthRequestOtp>>>
    export type PostAuthRequestOtpMutationBody = PostAuthRequestOtpBody
    export type PostAuthRequestOtpMutationError = void

    /**
 * @summary Send a one-time password to the supplied email or phone number
 */
export const usePostAuthRequestOtp = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRequestOtp>>, TError,{data: PostAuthRequestOtpBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuthRequestOtp>>,
        TError,
        {data: PostAuthRequestOtpBody},
        TContext
      > => {

      const mutationOptions = getPostAuthRequestOtpMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Retrieve the currently authenticated user
 */
export const getAuthMe = (
    getAuthMeBody?: GetAuthMeBody,
 signal?: AbortSignal
) => {
      
      
      return axiosAuth<void>(
      {url: `/auth/me`, method: 'GET',
      headers: {'Content-Type': 'application/json', }, signal
    },
      );
    }
  

export const getGetAuthMeQueryKey = (getAuthMeBody?: GetAuthMeBody,) => {
    return [`/auth/me`, getAuthMeBody] as const;
    }

    
export const getGetAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof getAuthMe>>, TError = void>(getAuthMeBody?: GetAuthMeBody, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthMeQueryKey(getAuthMeBody);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMe>>> = ({ signal }) => getAuthMe(getAuthMeBody, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthMe>>>
export type GetAuthMeQueryError = void


/**
 * @summary Retrieve the currently authenticated user
 */

export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = void>(
 getAuthMeBody?: GetAuthMeBody, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuthMeQueryOptions(getAuthMeBody,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



